export class CSVDataService {
  static exportToCsv(filename: string, rows: object[], firstrow: string) {
    if (!rows || !rows.length) {
      return;
    }
    const separator = ';';
    const keys = Object.keys(rows[0]);
   /* const csvContent = firstrow +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          if (k !== 'checked' && k !== 'checkbox' && k !== 'currentLodgeId') {
            let cell = row[k] === null || row[k] === undefined ? '' : row[k];
            if (k === 'isSubscriber') {
              cell === true ? cell = 'Ja' : cell = 'Nej';
            }
            cell = cell instanceof Date
              ? cell.toLocaleString()
              : cell.toString().replace(/"/g, '""');
            if (cell.search(/("|,|\n)/g) >= 0) {
              cell = `"${cell}"`;
            }
            return cell;
          }
        }).join(separator);
      }).join('\n');*/
      const csvContent = firstrow +
  '\n' +
  rows.map(row => {
    return keys
      .filter(k => k !== 'checked' && k !== 'checkbox' && k !== 'currentLodgeId') // Filtrera bort 'currentLodgeId'
      .map(k => {
        let cell = row[k] === null || row[k] === undefined ? '' : row[k];
        if (k === 'isSubscriber') {
          cell === true ? cell = 'Ja' : cell = 'Nej';
        }
        cell = cell instanceof Date
          ? cell.toLocaleString()
          : cell.toString().replace(/"/g, '""');
        if (cell.search(/("|,|\n)/g) >= 0) {
          cell = `"${cell}"`;
        }
        return cell;
      }).join(separator);
  }).join('\n');


    const blob = new Blob(['\ufeff', csvContent], { type: 'text/csv;charset=utf-8;' });
    if ((window.navigator as any).mSaveBlob) { // IE 10+
      (window.navigator as any).msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
}
